import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, createVNode as _createVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = { key: 1 }
const _hoisted_2 = { key: 2 }
const _hoisted_3 = { key: 3 }
const _hoisted_4 = { class: "page d-flex flex-row flex-column-fluid" }
const _hoisted_5 = {
  id: "kt_wrapper",
  class: "wrapper d-flex flex-column flex-row-fluid"
}
const _hoisted_6 = {
  id: "kt_content",
  class: "content d-flex flex-column flex-column-fluid"
}
const _hoisted_7 = {
  id: "kt_content_container",
  class: "container-fluid"
}
const _hoisted_8 = { class: "d-flex flex-center flex-column-auto pt-5" }
const _hoisted_9 = { class: "d-flex align-items-center fw-bold fs-6" }
const _hoisted_10 = { class: "d-none d-md-block" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_KTLoader = _resolveComponent("KTLoader")!
  const _component_KTAside = _resolveComponent("KTAside")!
  const _component_KTHeader = _resolveComponent("KTHeader")!
  const _component_router_view = _resolveComponent("router-view")!
  const _component_KTFooter = _resolveComponent("KTFooter")!
  const _component_MobileFooter = _resolveComponent("MobileFooter")!
  const _component_KTScrollTop = _resolveComponent("KTScrollTop")!
  const _component_KTDrawerMessenger = _resolveComponent("KTDrawerMessenger")!
  const _component_KTUserMenu = _resolveComponent("KTUserMenu")!
  const _component_KTCreateApp = _resolveComponent("KTCreateApp")!
  const _component_KTInviteFriendsModal = _resolveComponent("KTInviteFriendsModal")!
  const _component_KTUpgradePlanModal = _resolveComponent("KTUpgradePlanModal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.loaderEnabled)
      ? (_openBlock(), _createBlock(_component_KTLoader, {
          key: 0,
          logo: _ctx.loaderLogo
        }, null, 8, ["logo"]))
      : _createCommentVNode("", true),
    (_ctx.route.name === `dashboard` || _ctx.route.name === `AdminUserDashboard`)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [...(_cache[0] || (_cache[0] = [
          _createElementVNode("img", {
            class: "dashboard-left-shape",
            src: "/media/shape/yellow-shape.png",
            alt: "metronic"
          }, null, -1),
          _createElementVNode("img", {
            class: "dashboard-right-shape",
            src: "/media/shape/blue-shape.png",
            alt: "metronic"
          }, null, -1)
        ]))]))
      : (_ctx.route.name === `report` || _ctx.route.name === `/admin-report/`)
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [...(_cache[1] || (_cache[1] = [
            _createElementVNode("img", {
              class: "report-top-left-shape",
              alt: "metronic"
            }, null, -1),
            _createElementVNode("img", {
              class: "report-bottom-right-shape",
              alt: "metronic"
            }, null, -1)
          ]))]))
        : (_ctx.route.name === `survey-plus-report` || _ctx.route.name === `admin-survey-plus-report`)
          ? (_openBlock(), _createElementBlock("div", _hoisted_3, [...(_cache[2] || (_cache[2] = [
              _createElementVNode("img", {
                class: "survey-plus-top-right-shape",
                alt: "metronic"
              }, null, -1),
              _createElementVNode("img", {
                class: "survey-plus-bottom-left-shape",
                alt: "metronic"
              }, null, -1)
            ]))]))
          : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_4, [
      (_ctx.asideEnabled)
        ? (_openBlock(), _createBlock(_component_KTAside, {
            key: 0,
            lightLogo: _ctx.themeLightLogo,
            darkLogo: _ctx.themeDarkLogo
          }, null, 8, ["lightLogo", "darkLogo"]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_5, [
        _createVNode(_component_KTHeader, {
          title: _ctx.pageTitle,
          breadcrumbs: _ctx.breadcrumbs
        }, null, 8, ["title", "breadcrumbs"]),
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("div", _hoisted_7, [
            _createVNode(_component_router_view)
          ])
        ]),
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("div", _hoisted_10, [
              _createVNode(_component_KTFooter)
            ]),
            _createVNode(_component_MobileFooter)
          ])
        ])
      ])
    ]),
    _createVNode(_component_KTScrollTop),
    _createVNode(_component_KTDrawerMessenger),
    _createVNode(_component_KTUserMenu),
    _createVNode(_component_KTCreateApp),
    _createVNode(_component_KTInviteFriendsModal),
    _createVNode(_component_KTUpgradePlanModal)
  ], 64))
}